import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  imports: [],
  selector: 'app-youtube-player-iframe',
  templateUrl: './youtube-player-iframe.component.html',
})
export class YoutubePlayerIframeComponent {
  public readonly videoUrl = input.required<string>();
  public readonly maxHeight = input.required<number>();

  public readonly youtubeEmbedUrl = computed(() => {
    return this.getYoutubeEmbedUrl(this.videoUrl());
  });

  private readonly youtubeEmbedCache = new Map<string, SafeResourceUrl>();

  private readonly sanitizer = inject(DomSanitizer);

  public getYoutubeEmbedUrl(rawUrl: string): SafeResourceUrl {
    const cached = this.youtubeEmbedCache.get(rawUrl);

    if (cached) {
      return cached;
    }

    const idMatch = rawUrl.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/|youtube\.com\/live\/)([a-zA-Z0-9_-]+)/,
    );

    const videoId = idMatch ? idMatch[1] : rawUrl;
    const embed = `https://www.youtube.com/embed/${videoId}?controls=1&modestbranding=1&rel=0&playsinline=1&enablejsapi=0`;
    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    this.youtubeEmbedCache.set(rawUrl, safeUrl);

    return safeUrl;
  }
}
